import { axios } from '/plugins/axios.client';
import { errorFromResponse } from '/src/common/general-utils';
import { i18n } from '/plugins/i18n.client';
const errorHandler = errorFromResponse(i18n.global.t.bind(i18n));
import { toast } from '/plugins/toaster.client.js';

export default {
  /**
   * Gets the details of Active Maintenance
   * @returns {Object} details of Active Maintenance
   */
  async getActiveMaintenance() {
    try {
      return await axios.$get('/api/maintenance/get/active-maintenance');
    } catch (error) {
      toast.error(errorHandler('common.maintenance.active_maintenance_error', error));
      return null;
    }
  },
  /**
   * Checks if there exists an Active Maintenance
   * @returns {Boolean} result if active maintenance exist
   */
  async checkActiveMaintenance() {
    try {
      return await axios.$get('/api/maintenance/get/check-maintenance');
    } catch (error) {
      return false;
    }
  }
};
